export default "__VITE_ASSET__DsF$qOgN__"